import "./App.css";
import { createRoot } from "react-dom/client";
import widgetConfigs from "./configs/widgetConfig";
import SandboxViewer from "./SandboxViewerComponent/src/SandboxViewer";
import SearchAppBar from "components/AppBar";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";
import { Observer, observer } from "mobx-react";
import Expand from "@arcgis/core/widgets/Expand";
import Home from "@arcgis/core/widgets/Home";
import MeasurementWidget from "components/MeasurementWidget";
import React, { useEffect, useState } from "react";
import Track from "@arcgis/core/widgets/Track";
//import Compass from "@arcgis/core/widgets/Compass";
import PrintWidget from "components/print/printReact";
import * as watchUtils from "@arcgis/core/core/watchUtils";
import { ThemeProvider } from "@mui/material/styles";
import { lightTheme } from "theme";
import BottomBar from "components/BottomBar";
import Draggable from "react-draggable";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Identify from "./widgets/identify";
import LayerStore from "@giscon/utils.layer-store";
import APIHelper from "@giscon/utils.api-helper-esri";
import { autorun } from "mobx";
import { endpoints, baseBackendUrl } from "./configs/config";
const renderToDOM = (jsx, node) => {
  const root = createRoot(node);
  root.render(jsx);
  return root;
};

let previousMobileState = undefined;
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
function App() {
  const initLocateWidget = () => {
    const { mapStore } = RootStore;
    var locateWidget = new Track({
      useHeadingEnabled: true,
      view: mapStore.mapView,
    });
    // var compass = new Compass({
    //   view: mapStore.mapView
    // });

    // adds the home widget to the top left corner of the MapView
    mapStore.mapView.ui.add(locateWidget, "top-left");
    // mapStore.mapView.ui.add(compass, "top-left");
    mapStore.mapWidgets["locate"] = locateWidget;
  };
  const initHomeWidget = () => {
    const { mapStore } = RootStore;
    var homeWidget = new Home({
      view: mapStore.mapView,
    });

    // adds the home widget to the top left corner of the MapView
    mapStore.mapView.ui.add(homeWidget, "top-left");
    mapStore.mapWidgets["home"] = homeWidget;
  };

  const initPrintWidget = () => {
    const { mapStore } = RootStore;
    const node = document.createElement("div");
    node.style.visibility = "hidden";
    node.style.pointerEvents = "none";
    const printExpand = new Expand({
      id: "print-expand",
      expandIconClass: "esri-icon-printer",
      view: mapStore.mapView,
      content: node,
      expandTooltip: "Drucken",
      group: "map-widget-left",
      mode: "floating",
    });

    mapStore.mapView.ui.add(printExpand, {
      position: "top-left",
    });
    watchUtils.pausable(printExpand, "expanded", function (isExpanded) {
      RootStore.mapStore.setPrintWidgetExpanded(isExpanded);
      node.style.visibility = isExpanded ? "visible" : "hidden";
      node.style.pointerEvents = isExpanded ? null : "none";
      // if (!isExpanded) {
      //   mapStore.setPrintWidgetExpanded(isExpanded);
      // }
    });
    mapStore.mapView.ui.add(node, "bottom-left");

    RootStore.mapStore.setPrintWidgetExpanded(false);

    return renderToDOM(
      <ThemeProvider theme={lightTheme()}>
        <PrintWidget />
      </ThemeProvider>,
      node
    );
  };

  const initMeasurementWidget = () => {
    const { mapStore, communicationStore } = RootStore;
    const node = document.createElement("div");
    node.style.visibility = "hidden";
    node.style.pointerEvents = "none";

    const measureExpand = new Expand({
      id: "measure-expand",
      expandIconClass: "esri-icon-measure",
      view: mapStore.mapView,
      content: node,
      expandTooltip: "Messen",
      group: "map-widget-left",
      mode: "floating",
    });
    mapStore.mapView.ui.add(measureExpand, {
      position: "top-left",
    });

    watchUtils.pausable(measureExpand, "expanded", function (isExpanded) {
      node.style.visibility = isExpanded ? "visible" : "hidden";
      node.style.pointerEvents = isExpanded ? null : "none";
    });

    mapStore.mapView.ui.add(node, "bottom-left");
    measureExpand.expanded = false;
    return renderToDOM(
      <MeasurementWidget
        deactivate={() => {
          measureExpand.expanded = false;
        }}
        CommunicationStore={communicationStore}
      />,
      node
    );
  };

  const initAttribution = () => {
    const { mapStore } = RootStore;
    const node = document.createElement("div");
    node.className = "attributation";
    node.title =
      "Die Nutzung des WMS ist eingeschränkt und richtet sich nach den Bedingungen für die Verwendung von Angaben und Präsentationen des amtlichen Vermessungswesens (Verwendungs- und Geschäftsbedingungen)";
    node.onclick = (e) => {
      setOpen(true);
    };
    mapStore.mapView.container.append(node);
  };
  const [open, setOpen] = React.useState(false);
  const [backendError, setBackendError] = useState(null);
  const swaggerUrl = /\/api\/?$/i.test(baseBackendUrl)
    ? baseBackendUrl.replace(/\/api\/?$/i, "/swagger")
    : new URL("swagger", baseBackendUrl).href;

  const handleClose = () => {
    setOpen(false);
  };
  const openLGLN = (e) => {
    window.open("http://www.lgln.niedersachsen.de/", "lgln");
  };
  const initIdentify = () => {
    const { mapStore, communicationStore } = RootStore;
    const { map, view } = LayerStore;
    const node = document.createElement("div");
    const icon = document.createElement("div");
    icon.title = "Layer-Informationen";
    icon.style.padding = "8px";
    icon.className =
      "esri-icon-description esri-expand esri-expand--floating  esri-widget esri-component";
    let active = false;
    let inactive = true;
    const renderButton = () => {
      if (inactive) {
        icon.style.background = "#fff";
      } else {
        if (active) {
          icon.style.background = "#f280a0";
        } else if (!active) {
          icon.style.background = "#fff";
        }
      }
    };
    const root = createRoot(node);

    const mobileRoot = document.createElement("div");
    const mobileContentWrapper = document.createElement("div");
    mobileContentWrapper.style.width = "300px";
    mobileContentWrapper.style.maxWidth = "calc(100% - 20px)";
    mobileContentWrapper.style.marginTop = "25px";
    const mobileClose = document.createElement("div");
    mobileClose.style.position = "absolute";
    mobileClose.style.height = "20px";
    mobileClose.style.width = "20px";
    mobileClose.style.top = "20px";
    mobileClose.style.right = "20px";
    mobileClose.style.color = "#F599B3"; // TODO: right color
    mobileClose.style.cursor = "pointer";
    mobileClose.style.fontSize = "20px";
    mobileClose.innerText = "X";
    mobileClose.addEventListener("click", () => {
      mobileRoot.style.display = "none";
      active = false;
      render();
      renderButton();
    });

    mobileRoot.style.position = "absolute";
    mobileRoot.style.justifyContent = "center";
    // mobileRoot.style.alignItems = "center";
    mobileRoot.style.left = "0px";
    mobileRoot.style.right = "0px";
    mobileRoot.style.bottom = "0px";
    mobileRoot.style.height = "300px";
    mobileRoot.style.maxHeight = "100%";
    mobileRoot.style.background = "#FFF";
    mobileRoot.className = "mobileIdentifyRoot";
    mobileRoot.style.display = "none";
    mobileRoot.appendChild(mobileContentWrapper);
    const infoHeader = document.createElement("h3");
    infoHeader.textContent = "Info";
    mobileContentWrapper.appendChild(infoHeader);
    mobileRoot.appendChild(mobileClose);
    document.body.appendChild(mobileRoot);

    const showOnMapNonMobile = (mapPoint) => {
      mobileRoot.style.display = "none";
      APIHelper.showMapTip(map, view, mapPoint, node);
      const popup = view.popup;
      popup.when((e) => {
        popup.collapseEnabled = false;
        popup.dockEnabled = false;
        popup.reposition();
      });
      return () => {
        try {
          popup.close();
        } catch (e) {
          console.warn(e);
        }
      };
    };

    const showOnMapMobile = (mapPoint) => {
      mobileRoot.style.display = "flex";
      mobileContentWrapper.appendChild(node);

      return () => {
        mobileRoot.style.display = "none";
      };
    };

    const render = () => {
      root.render(
        <ThemeProvider theme={lightTheme()}>
          <Observer>
            {() => {
              const showOnMap = RootStore.uiStore.BBStore.mobile
                ? showOnMapMobile
                : showOnMapNonMobile;
              return (
                <Identify
                  map={map}
                  view={view}
                  active={active}
                  showOnMap={showOnMap}
                  setInactive={(value) => {
                    inactive = value;
                    render();
                    renderButton();
                  }}
                  CommunicationStore={communicationStore}
                  setActive={(value) => {
                    active = value;
                    render();
                    renderButton();
                  }}
                />
              );
            }}
          </Observer>
        </ThemeProvider>
      );
    };
    icon.addEventListener(
      "click",
      () => {
        active = !active;
        renderButton();
        render();
      },
      false
    );
    render();
    renderButton();

    mapStore.mapView.ui.add(icon, {
      position: "top-left",
    });
    return root;
  };

  useEffect(() => {
    const roots = [];
    roots.push(initHomeWidget());
    roots.push(initLocateWidget());
    if (!RootStore.uiStore.BBStore.isMobileDevice)
      roots.push(initMeasurementWidget());
    roots.push(initPrintWidget());
    roots.push(initAttribution());
    roots.push(initIdentify());
    return () => {
      roots.forEach((root) => {
        // Defer unmount to avoid "synchronous unmount during render" race condition
        // (React 18 throws if unmount is called synchronously during an active render).
        setTimeout(() => root?.unmount(), 0);
      });
    };
  }, []);

  // Fetch services from backend and store in CommunicationStore
  useEffect(() => {
    let aborted = false;

    // Set loading state
    RootStore.communicationStore.addMessage({
      to: "regionalSelectionServicesLoading",
      message: true,
    });

    const controller = new AbortController();

    fetch(endpoints.servicesUrl, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Backend antwortet mit HTTP ${response.status} ${response.statusText} (${endpoints.servicesUrl}).`
          );
        }
        return response.json();
      })
      .then((data) => {
        if (!aborted) {
          setBackendError(null);
          let serviceList = [];
          if (Array.isArray(data)) {
            serviceList = data;
          } else if (Array.isArray(data?.Services)) {
            serviceList = data.Services;
          }
          const sortedServices = serviceList.sort(
            (a, b) => a.OrderNumber - b.OrderNumber
          );
          RootStore.communicationStore.addMessage({
            to: "regionalSelectionServices",
            message: sortedServices,
          });
          RootStore.communicationStore.addMessage({
            to: "regionalSelectionServicesLoading",
            message: false,
          });
          RootStore.communicationStore.addMessage({
            to: "regionalSelectionServicesError",
            message: null,
          });
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        if (!aborted) {
          // Bootstrap call failed (HTTP or network): app cannot initialize reliably.
          setBackendError(error.message);
          console.error("Error loading regional selection services:", error);
          RootStore.communicationStore.addMessage({
            to: "regionalSelectionServicesLoading",
            message: false,
          });
          RootStore.communicationStore.addMessage({
            to: "regionalSelectionServicesError",
            message: error.message,
          });
        }
      });

    return () => {
      aborted = true;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    return autorun(() => {
      const mobile = RootStore.uiStore.BBStore.mobile;
      const leftStore = RootStore.uiStore.subUiStores["left"];
      const rightStore = RootStore.uiStore.subUiStores["right"];
      if (mobile && previousMobileState !== mobile) {
        const left = leftStore.activeWidgetId;
        const right = rightStore.activeWidgetId;
        if (left && right) {
          rightStore.closeWidget(right);
        }
      }
    });
  }, []);

  return (
    <SandboxViewer
      AppBar={SearchAppBar}
      widgetsConfig={widgetConfigs}
      requestsConfig={widgetConfigs.requestsConfig}
      BottomBar={BottomBar}
      mapConfig={{
        locale: "de",
        constraints: {
          minScale: 2500000,
          maxScale: 10000,
          rotationEnabled: false,
        },

        map: {
          center: {
            spatialReference: { wkid: 25832 },
            x: 514921.5,
            y: 5833105,
          },
          zoom: 8,
        },
      }}
    >
      <Dialog
        scroll="paper"
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Copyright
        </DialogTitle>
        <DialogContent>
          Die Nutzung des WMS ist eingeschränkt und richtet sich nach den
          Bedingungen für die Verwendung von Angaben und Präsentationen des
          amtlichen Vermessungswesens (Verwendungs- und Geschäftsbedingungen) -{" "}
          <a href="# " onClick={openLGLN}>
            http://www.lgln.niedersachsen.de/
          </a>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={handleClose}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>

      {/* Backend error overlay — shown on startup health-check failure */}
      {backendError && (
        <Box
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={9999}
          bgcolor="rgba(255,255,255,0.96)"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Stack
            alignItems="center"
            spacing={3}
            sx={{ maxWidth: 480, px: 3, textAlign: "center" }}
          >
            <ErrorOutlineIcon sx={{ fontSize: 72, color: "error.main" }} />
            <Typography variant="h5" fontWeight="bold">
              Backend Fehler
            </Typography>
            <Typography color="text.secondary">{backendError}</Typography>
            <Typography>
              Fehler bei der Verbindung zum Backend (
              {<code>{baseBackendUrl}</code>}). Bitte prüfen Sie ob das Backend
              läuft — Swagger:{" "}
              <a href={swaggerUrl} target="_blank" rel="noreferrer">
                {swaggerUrl}
              </a>
              . Backend-URL in <code>runtime-config.js</code> anpassen falls
              nötig.
            </Typography>
          </Stack>
        </Box>
      )}
    </SandboxViewer>
  );
}
export default observer(App);
